import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

// Master-editable site copy. Fetches GET /api/site-content and re-fetches
// whenever a master saves an edit (nt-content-changed window event).
export function useSiteContent() {
  const [data, setData] = useState(null);
  useEffect(() => {
    let live = true;
    const load = () =>
      fetch(`${API}/api/site-content`)
        .then((r) => (r.ok ? r.json() : null))
        .then((d) => {
          if (live && d) setData(d);
        })
        .catch(() => {});
    load();
    window.addEventListener("nt-content-changed", load);
    return () => {
      live = false;
      window.removeEventListener("nt-content-changed", load);
    };
  }, []);
  const t = (key, fallback) => data?.content?.[key] ?? fallback;
  return { t, meta: data?.meta || {}, loaded: Boolean(data) };
}
